/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_ItalicInputs */

const en_editor_italic = /** @type {(inputs: Editor_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italic`)
};

/**
* | output |
* | --- |
* | "Italic" |
*
* @param {Editor_ItalicInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const editor_italic = /** @type {((inputs?: Editor_ItalicInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_ItalicInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_editor_italic(inputs)
});